import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaLock, FaCookie, FaDatabase, FaUserShield, FaEnvelope } from 'react-icons/fa';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
            <FaShieldAlt className="text-white text-3xl" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Gizlilik Politikası
          </h1>
          <p className="text-gray-600">
            Son Güncelleme: 9 Kasım 2025
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-xl p-8 space-y-8">

          {/* Section 1 */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <FaUserShield className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">1. Genel Bilgiler</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>
                <strong>Döviz Defteri</strong> olarak, kullanıcılarımızın gizliliğine büyük önem veriyoruz.
                Bu Gizlilik Politikası, hizmetlerimizi kullanırken toplanan, kullanılan ve korunan
                kişisel verileriniz hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.
              </p>
              <p>
                Bu politika, 6698 sayılı <strong>Kişisel Verilerin Korunması Kanunu (KVKK)</strong> ve
                Avrupa Birliği <strong>Genel Veri Koruma Yönetmeliği (GDPR)</strong> uyarınca düzenlenmiştir.
              </p>
              <p>
                Hizmetimizi kullanarak, bu Gizlilik Politikası'nda açıklanan uygulamaları kabul etmiş olursunuz.
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaDatabase className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">2. Toplanan Veriler</h2>
            </div>
            <div className="text-gray-700 space-y-4 leading-relaxed">
              <div>
                <h3 className="font-semibold text-lg mb-2">2.1. Hesap Bilgileri</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Ad ve Soyad</li>
                  <li>E-posta Adresi</li>
                  <li>Şifre (şifrelenmiş olarak saklanır)</li>
                  <li>Hesap oluşturma tarihi</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">2.2. Portföy Verileri</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Eklediğiniz döviz ve altın türleri</li>
                  <li>Miktar ve alış fiyat bilgileri</li>
                  <li>Portföy oluşturma ve güncelleme tarihleri</li>
                  <li>İşlem geçmişi (ekleme, silme, güncelleme)</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">2.3. Teknik Veriler</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>IP Adresi</li>
                  <li>Tarayıcı türü ve sürümü</li>
                  <li>Cihaz bilgileri (işletim sistemi, ekran çözünürlüğü)</li>
                  <li>Giriş saatleri ve sıklığı</li>
                  <li>Sayfa görüntüleme istatistikleri</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">2.4. İletişim Verileri</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>E-posta doğrulama kayıtları</li>
                  <li>Sistem bildirimleri ve güncelleme tercihleri</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaLock className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">3. Verilerin Kullanım Amaçları</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>Toplanan veriler aşağıdaki amaçlarla kullanılır:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Hizmet Sunumu:</strong> Döviz ve altın portföy takip hizmetini sağlamak,
                  güncel kur bilgilerini göstermek
                </li>
                <li>
                  <strong>Hesap Yönetimi:</strong> Kullanıcı kimlik doğrulama, oturum yönetimi,
                  şifre sıfırlama işlemleri
                </li>
                <li>
                  <strong>İletişim:</strong> E-posta doğrulama, sistem bildirimleri, önemli güncellemeler
                </li>
                <li>
                  <strong>Güvenlik:</strong> Yetkisiz erişim tespiti, dolandırıcılık önleme,
                  sistem güvenliğini sağlama
                </li>
                <li>
                  <strong>Analiz ve İyileştirme:</strong> Hizmet kalitesini artırmak,
                  kullanıcı deneyimini geliştirmek
                </li>
                <li>
                  <strong>Yasal Yükümlülükler:</strong> Kanuni düzenlemelere ve yetkili makam
                  taleplerine uyum sağlamak
                </li>
              </ul>
            </div>
          </section>

          {/* Section 4 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaCookie className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">4. Çerezler ve Yerel Depolama</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>Hizmetimiz aşağıdaki teknolojileri kullanır:</p>

              <div>
                <h3 className="font-semibold text-lg mb-2">4.1. LocalStorage / SessionStorage</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Oturum bilgilerinizi saklamak için kullanılır</li>
                  <li>JWT (JSON Web Token) authentication token'ı içerir</li>
                  <li>"Beni Unutma" seçeneği ile kalıcı veya geçici saklanabilir</li>
                  <li>Tarayıcınızı temizleyerek silebilirsiniz</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">4.2. Zorunlu Çerezler</h3>
                <p>
                  Hizmetin temel işlevselliği için gereklidir. Bu çerezler olmadan
                  oturum açma ve portföy yönetimi gibi özellikler çalışmaz.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">4.3. Çerez Yönetimi</h3>
                <p>
                  Tarayıcı ayarlarınızdan çerezleri reddedebilir veya silebilirsiniz.
                  Ancak bu durumda bazı özellikler düzgün çalışmayabilir.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaShieldAlt className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">5. Veri Güvenliği</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>Verilerinizi korumak için aşağıdaki güvenlik önlemlerini alıyoruz:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Şifreleme:</strong> Tüm şifreler bcrypt algoritması ile hash'lenerek saklanır.
                  Düz metin şifreler asla saklanmaz.
                </li>
                <li>
                  <strong>HTTPS:</strong> Tüm veri iletişimi SSL/TLS şifrelemesi ile korunur.
                </li>
                <li>
                  <strong>JWT Authentication:</strong> Güvenli token tabanlı kimlik doğrulama sistemi.
                </li>
                <li>
                  <strong>Rate Limiting:</strong> Brute force saldırılarına karşı istek sınırlama.
                </li>
                <li>
                  <strong>Security Headers:</strong> Helmet.js ile güvenlik başlıkları (CORS, CSP, vb.).
                </li>
                <li>
                  <strong>Düzenli Güncellemeler:</strong> Sistem ve bağımlılıkların güvenlik açıklarına
                  karşı güncel tutulması.
                </li>
                <li>
                  <strong>Erişim Kontrolü:</strong> Yalnızca yetkili personelin veritabanına erişimi.
                </li>
              </ul>
            </div>
          </section>

          {/* Section 6 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaUserShield className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">6. Veri Saklama Süresi</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Hesap Verileri:</strong> Hesabınızı silene kadar veya 2 yıl boyunca
                  aktif olmadığınız takdirde otomatik olarak silinir.
                </li>
                <li>
                  <strong>Portföy Verileri:</strong> Hesap silindiğinde tüm portföy verileri
                  kalıcı olarak silinir.
                </li>
                <li>
                  <strong>Log Kayıtları:</strong> Güvenlik ve hata ayıklama amaçlı loglar
                  maksimum 30 gün süreyle saklanır.
                </li>
                <li>
                  <strong>E-posta Doğrulama:</strong> Doğrulama token'ları 24 saat sonra otomatik olarak silinir.
                </li>
                <li>
                  <strong>Yasal Saklama:</strong> Yasal zorunluluklar gereği bazı veriler
                  belirlenen süre boyunca arşivlenebilir.
                </li>
              </ul>
            </div>
          </section>

          {/* Section 7 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaEnvelope className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">7. Üçüncü Taraf Paylaşımı</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>
                <strong>Verilerinizi üçüncü taraflarla PAYLAŞMIYORUZ, SATMIYORUZ veya KİRALAMIYORUZ.</strong>
              </p>
              <p>Aşağıdaki durumlar hariç:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Hizmet Sağlayıcılar:</strong>
                  <ul className="list-circle list-inside ml-6 mt-1">
                    <li>Render.com (Backend Hosting)</li>
                    <li>Vercel (Frontend Hosting)</li>
                    <li>MongoDB Atlas (Veritabanı)</li>
                    <li>Resend.com (E-posta Gönderimi)</li>
                  </ul>
                  <p className="mt-2">
                    Bu hizmet sağlayıcılar yalnızca hizmet sunumu için gerekli verilere erişir
                    ve kendi gizlilik politikalarına tabidirler.
                  </p>
                </li>
                <li>
                  <strong>Yasal Zorunluluklar:</strong> Mahkeme kararı, yasal düzenlemeler veya
                  kamu otoritelerinin talepleri halinde.
                </li>
                <li>
                  <strong>Güvenlik Gerekçeleri:</strong> Dolandırıcılık, güvenlik ihlali gibi
                  durumlarda yetkili makamlara bildirim.
                </li>
              </ul>
            </div>
          </section>

          {/* Section 8 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaUserShield className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">8. Kullanıcı Hakları (KVKK Uyarınca)</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>
                6698 sayılı KVKK'nın 11. maddesi gereğince, kişisel verilerinizle ilgili
                aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp
                  kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
                <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların
                  düzeltilmesini isteme</li>
                <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin
                  silinmesini veya yok edilmesini isteme</li>
                <li>Düzeltme, silme ve yok edilme işlemlerinin, kişisel verilerin aktarıldığı
                  üçüncü kişilere bildirilmesini isteme</li>
                <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi
                  suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız
                  hâlinde zararın giderilmesini talep etme</li>
              </ul>
              <div className="bg-blue-50 border-l-4 border-blue-600 p-4 mt-4 rounded">
                <p className="font-semibold">Haklarınızı Kullanmak İçin:</p>
                <p className="mt-2">
                  Yazılı olarak veya KVKK'da öngörülen diğer yöntemlerle başvurabilirsiniz.
                  Başvurularınız en geç 30 gün içinde ücretsiz olarak sonuçlandırılır.
                </p>
              </div>
            </div>
          </section>

          {/* Section 9 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaDatabase className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">9. Hesap Silme</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>Hesabınızı ve tüm verilerinizi tamamen silmek için:</p>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>Hesap ayarlarınıza gidin</li>
                <li>"Hesabımı Sil" seçeneğine tıklayın</li>
                <li>E-posta doğrulama ile onaylayın</li>
              </ol>
              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4 rounded">
                <p className="font-semibold text-yellow-800">Uyarı:</p>
                <p className="text-yellow-700 mt-2">
                  Hesabınızı sildiğinizde tüm portföy verileriniz, işlem geçmişiniz ve
                  kişisel bilgileriniz <strong>kalıcı olarak silinir</strong> ve
                  <strong>geri alınamaz</strong>.
                </p>
              </div>
            </div>
          </section>

          {/* Section 10 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaShieldAlt className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">10. Çocukların Gizliliği</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>
                Hizmetimiz 18 yaşından küçük kişilere yönelik değildir. Bilerek 18 yaşın
                altındaki çocuklardan kişisel veri toplamıyoruz.
              </p>
              <p>
                Eğer 18 yaşından küçük bir çocuğun bize kişisel veri sağladığını fark ederseniz,
                lütfen bizimle iletişime geçin. Bu durumda, ilgili verileri derhal sileriz.
              </p>
            </div>
          </section>

          {/* Section 11 */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaEnvelope className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">11. Politika Güncellemeleri</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>
                Bu Gizlilik Politikası zaman zaman güncellenebilir. Önemli değişiklikler
                olduğunda sizi e-posta yoluyla bilgilendireceğiz.
              </p>
              <p>
                Güncellemeleri bu sayfadan takip edebilir ve "Son Güncelleme" tarihini
                kontrol edebilirsiniz.
              </p>
              <p>
                Politika güncellemelerinden sonra hizmeti kullanmaya devam etmeniz,
                yeni politikayı kabul ettiğiniz anlamına gelir.
              </p>
            </div>
          </section>

          {/* Section 12 - Contact */}
          <section className="border-t pt-8">
            <div className="flex items-center gap-3 mb-4">
              <FaEnvelope className="text-blue-600 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-900">12. İletişim</h2>
            </div>
            <div className="text-gray-700 space-y-3 leading-relaxed">
              <p>
                Gizlilik Politikası ile ilgili sorularınız, talepleriniz veya şikayetleriniz için:
              </p>
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg mt-4">
                <p className="font-semibold text-lg mb-3">Veri Sorumlusu:</p>
                <ul className="space-y-2">
                  <li><strong>Platform:</strong> Döviz Defteri</li>
                  <li><strong>Web:</strong> <a href="https://www.dovizdefteri.com" className="text-blue-600 hover:underline">www.dovizdefteri.com</a></li>
                  <li><strong>E-posta:</strong> <a href="mailto:kaanfurkankaya@gmail.com" className="text-blue-600 hover:underline">kaanfurkankaya@gmail.com</a></li>
                </ul>
                <p className="mt-4 text-sm text-gray-600">
                  Başvurularınız en geç 30 gün içinde değerlendirilip cevaplanacaktır.
                </p>
              </div>
            </div>
          </section>

          {/* Footer Navigation */}
          <div className="border-t pt-8 text-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg"
            >
              Ana Sayfaya Dön
            </Link>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-center text-sm text-gray-600">
          <p>
            Bu politika son olarak <strong>9 Kasım 2025</strong> tarihinde güncellenmiştir.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;

